import { useEffect, useState } from "react";
import { api, formatDate, formatError } from "../lib/api";
import { PageHeader } from "../components/ui-kit";

export default function EntriesPage() {
  const [entries, setEntries] = useState([]);
  const [materials, setMaterials] = useState([]);
  const [material_id, setMid] = useState("");
  const [quantity, setQty] = useState(1);
  const [note, setNote] = useState("");
  const [msg, setMsg] = useState("");

  const load = () => {
    api.get("/material-entries").then((r) => setEntries(r.data));
    api.get("/materials").then((r) => setMaterials(r.data));
  };
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setMsg("");
    try {
      await api.post("/material-entries", { material_id, quantity: Number(quantity), note });
      setMid(""); setQty(1); setNote("");
      setMsg("Entrada registrada com sucesso");
      load();
    } catch (err) { setMsg(formatError(err)); }
  };

  return (
    <div data-testid="entries-page">
      <PageHeader eyebrow="Estoque" title="Entradas de Materiais" />

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <form className="card p-5" onSubmit={submit} data-testid="entry-form">
          <h3 className="label-caps mb-4">Nova Entrada</h3>
          {msg && <div className="mb-3 text-xs p-2 border" style={{ borderColor: "var(--border-strong)", color: "var(--text-dim)" }}>{msg}</div>}
          <label className="label-caps block mb-1">Material</label>
          <select className="select mb-3" value={material_id} onChange={(e) => setMid(e.target.value)} required data-testid="entry-material">
            <option value="">Selecione</option>
            {materials.map((m) => <option key={m.id} value={m.id}>{m.code} — {m.name}</option>)}
          </select>
          <label className="label-caps block mb-1">Quantidade</label>
          <input className="input mono mb-3" type="number" min="1" value={quantity} onChange={(e) => setQty(e.target.value)} required data-testid="entry-quantity" />
          <label className="label-caps block mb-1">Observação</label>
          <input className="input mb-4" value={note} onChange={(e) => setNote(e.target.value)} data-testid="entry-note" placeholder="Opcional: NF, fornecedor..." />
          <button className="btn btn-primary w-full" type="submit" data-testid="entry-submit">Registrar Entrada</button>
        </form>

        <div className="card lg:col-span-2">
          <div className="px-5 py-4 border-b" style={{ borderColor: "var(--border)" }}>
            <h3 className="label-caps">Histórico</h3>
          </div>
          <table className="data">
            <thead><tr><th>Data</th><th>Material</th><th>Qtd</th><th>Obs</th></tr></thead>
            <tbody>
              {entries.map((e) => (
                <tr key={e.id}>
                  <td>{formatDate(e.date)}</td>
                  <td>{e.material_name}</td>
                  <td className="mono">+{e.quantity}</td>
                  <td style={{ color: "var(--text-dim)" }}>{e.note || "-"}</td>
                </tr>
              ))}
              {entries.length === 0 && <tr><td colSpan={4} className="text-center py-10 text-sm" style={{ color: "var(--text-mute)" }}>Nenhuma entrada registrada.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
